import { Move, Plus, Hand, RotateCw, Trash2 } from "lucide-react";

const MODES = [
  { id: "move", label: "Verschieben", icon: Move },
  { id: "add", label: "Hinzufügen", icon: Plus },
  { id: "moveAll", label: "Alle verschieben", icon: Hand },
];
const HINT = {
  move: "Modul antippen zum Auswählen, ziehen zum Verschieben.",
  add: "Auf das Dach tippen, um dort ein Modul zu setzen.",
  moveAll: "Ein beliebiges Modul ziehen – die ganze Belegung wandert mit.",
};

export const segBtn = (active) => `h-9 px-2 sm:px-3 text-[11.5px] sm:text-[12px] font-bold whitespace-nowrap inline-flex items-center justify-center gap-1.5 transition-colors ${
  active ? "bg-[#00E575] text-[#09090B]" : "bg-zinc-900 text-zinc-300 hover:bg-zinc-800"}`;

export function LayoutModeBar({ mode, setMode, selectedPanel, onRotate, onDelete }) {
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex w-full sm:w-auto rounded-lg overflow-hidden border border-zinc-700 [&>button]:flex-1 sm:[&>button]:flex-none" role="group">
          {MODES.map(({ id, label, icon: Icon }) => (
            <button key={id} type="button" onClick={() => setMode(id)} className={segBtn(mode === id)} data-testid={`roof-layout-mode-${id.toLowerCase()}`}>
              <Icon size={13} /> {label}
            </button>
          ))}
        </div>
        <button type="button" onClick={onRotate} disabled={!selectedPanel} data-testid="roof-layout-rotate-selected"
          className="h-9 px-3 rounded-lg border border-sky-500/40 text-sky-200 text-[12px] font-bold inline-flex items-center gap-1.5 hover:bg-sky-500/10 disabled:opacity-40 disabled:pointer-events-none">
          <RotateCw size={13} /> {selectedPanel?.landscape ? "Hochkant drehen" : "Quer drehen"}
        </button>
        <button type="button" onClick={onDelete} disabled={!selectedPanel} data-testid="roof-layout-delete-selected"
          className="h-9 px-3 rounded-lg border border-rose-500/40 text-rose-200 text-[12px] font-bold inline-flex items-center gap-1.5 hover:bg-rose-500/10 disabled:opacity-40 disabled:pointer-events-none">
          <Trash2 size={13} /> Modul löschen
        </button>
      </div>
      <p className="text-[11.5px] text-zinc-500" data-testid="roof-layout-mode-hint">{HINT[mode]} Tastatur: Entf = löschen, R = drehen.</p>
    </div>
  );
}
